import CardFrameSurface from "./CardFrameSurface";

export default function Card({ card }) {
  if (!card) return null;

  return (
    <CardFrameSurface className="mx-auto h-[480px] w-[320px]">
      <div className="absolute inset-12 pb-20 flex flex-col rounded-lg">
        <div
          className="flex-1 overflow-y-auto space-y-4 text-center px-1 rounded"
        >
          {/* Main Question */}
          {card.question && (
            <p className="text-lg font-semibold text-gray-900">{card.question}</p>
          )}

          {/* Only show if translationLanguage is present */}
          {card.translation && card.translationLanguage !== "Not provided" && (
            <div className="space-y-2">
              <p className="text-sm text-gray-700">{card.translation}</p>
              <p className="text-xs text-gray-400 italic">
                Translated to: {card.translationLanguage}
              </p>
            </div>
          )}
        </div>
      </div>
    </CardFrameSurface>
  );
}
